import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto relative rounded-2xl overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20soft%20abstract%20texture%20with%20warm%20cream%20and%20rose%20gold%20gradients%2C%20luxurious%20fabric%20folds%2C%20sophisticated%20minimalist%20background%2C%20subtle%20light%20reflections%2C%20premium%20editorial%20quality&width=1200&height=500&seq=cta-bg-01&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 via-primary-800/60 to-primary-900/80" />
        </div>

        {/* Content */}
        <div className="relative z-10 text-center py-12 md:py-16 px-6 md:px-10">
          <p className="text-xs md:text-sm font-label text-accent-300/80 tracking-[0.2em] uppercase mb-2">
            Start Your Journey
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-background-50 mb-3">
            开启您的品质探索之旅
          </h2>
          <p className="text-sm md:text-base text-background-300/90 max-w-lg mx-auto mb-6 md:mb-8">
            加入臻品阁，发现全球高品质成人精品。安全私密，品质保障，让每一次体验都臻于完美
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category"
              className="px-8 py-3 text-sm font-label font-medium whitespace-nowrap rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors cursor-pointer"
            >
              立即探索精品
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 text-sm font-label font-medium whitespace-nowrap rounded-full border border-background-300/40 text-background-100 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}